































































import Vue from 'vue';
import { OptionsFieldInterface } from '@/types';

export default Vue.extend({
  name: 'FieldSelect',
  props: {
    name: { type: String },
    value: {
      type: [String, Number],
      required: false,
    },
    label: {
      type: String,
      default: '',
    },
    hint: { type: String },
    options: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'select',
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    Vue.nextTick(() => {
      this.fieldValue = this.getValue;
    });
  },
  watch: {
    value: function () {
      this.fieldValue = this.getValue;
    },
    getValue() {
      this.fieldValue = this.getValue;
    },
  },
  computed: {
    placeholderForAutocomplete(): string {
      if (this.options.length == 0 && this.value) {
        return this.value + '';
      }
      return this.placeholder;
    },
    getValue(): OptionsFieldInterface | null {
      if (this.value === '' || this.value == undefined) {
        return null;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return this.options.find((item: OptionsFieldInterface): boolean => {
        return item.value == this.value;
      });
    },
    getId(): string {
      if (!this.name) {
        return '_' + Math.random().toString(36).substr(2, 9);
      }
      return this.name.replace('[', '-').replace(']', '').toLowerCase();
    },

    issetLabel(): boolean {
      return this.label !== '';
    },
    isFilled(): boolean {
      return !!this.fieldValue;
    },
    error(): string {
      return this.errors.join(', ');
    },
  },
  methods: {
    input() {
      this.$emit(
        'input',
        this.fieldValue ? this.fieldValue.value.toString() : null
      );
      this.change();
      this.returnObject();
    },
    change() {
      this.$emit(
        'change',
        this.fieldValue ? this.fieldValue.value.toString() : null
      );
    },
    returnObject() {
      this.$emit('returnObject', this.fieldValue)
    },
    onSearch(search: string, loading: (param: boolean) => void) {
      loading(true);
      this.search(search, loading);
    },
    search(search: string, loading: (param: boolean) => void) {
      this.$emit('search', search);
      loading(false);
    },
    focus(search: string) {
      this.$emit('focus', search);
    },
  },
  data: function () {
    return {
      fieldValue: {
        label: '',
        value: '',
      } as OptionsFieldInterface | null,
    };
  },
});
